import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface AWBsSelectType {
    name: string;
}

@Injectable()
export class NominationHandlerService {
    private _awbs: BehaviorSubject<AWBsSelectType[]> = new BehaviorSubject<AWBsSelectType[]>([]);

    setAWBsList(awbs: string[]): void {
        const _awbs = awbs.map((awb) => ({
            name: awb,
        }));

        this._awbs.next(_awbs);
    }

    getAWBList(): Observable<AWBsSelectType[]> {
        return this._awbs.asObservable();
    }
}
